import React from 'react';
import { Button } from 'react-bootstrap';


const NotRegistered = () => {

    const HandleNotRegistered = () => {
        localStorage.clear()
        window.location.reload()
    }

    return ( 

        <div style={{width:'100%', 
                    height:'100%', 
                    display:'flex', 
                    flexDirection:'column',  
                    alignItems:'center'
                }}>
            <img src="images/animated_splash.gif" 
                alt="ApiAnimation" 
                style={{width:'70%', 
                        marginBottom:'10%', 
                        marginTop:'30%'
                    }}
            />
            <div style={{
                width:'85%',
                height:'120px',
                borderRadius: '20px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                
            }}>
                <p
                style={{fontSize:'15px', textAlign:"center"}}
                >
                    شما ثبت نام نکرده اید!<br/> برای راهنمایی، با شماره 09120827616 تماس بگیرید.
                    </p>
            </div>
            <Button
                style={{backgroundColor:'rgb(241 139 139)', 
                        border:'1px solid red', 
                        marginTop:'10%', 
                        fontSize:'12px'
                    }}
                onClick={() => HandleNotRegistered()}
            >وارد کردن شماره همراه جدید
            </Button>
        
        </div>
    );
}
 
export default NotRegistered;